import { SubscriptionName } from '@anm/api/modules/subscription';

const isTeamSubscription = (subscription: SubscriptionName) => subscription.includes('WaveTeam');

export default isTeamSubscription;
